module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"Sign in with {name}","signup":"Sign up with {name}","reauth":"Reauth with {name}","email":"your email","test":"Create test account"},"fr":{"login":"Se connecter avec {name}","signup":"S\u0027inscrire avec {name}","reauth":"Se reconnecter avec {name}","email":"votre email","test":"Créer un compte de test"}}')
  delete Component.options._Ctor
}
